import styled from 'styled-components';

export const StyledPrescriptionIssuingAccessField = styled.div`
   display: flex;
   flex-direction: column;
   gap: 4px;
`;
StyledPrescriptionIssuingAccessField.displayName = 'StyledPrescriptionIssuingAccessField';
